import { render, staticRenderFns } from "./product-tp-patient.vue?vue&type=template&id=35c0c5a8&scoped=true&lang=pug&"
import script from "./product-tp-patient.vue?vue&type=script&lang=ts&"
export * from "./product-tp-patient.vue?vue&type=script&lang=ts&"
import style0 from "./product-tp-patient.vue?vue&type=style&index=0&id=35c0c5a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c0c5a8",
  null
  
)

export default component.exports